import styled from "styled-components";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

export const StyledText = styled.p`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["0"],
        $weight: 700,
        $size: 14,
        $family: fonts.$dmSansFontFamily,
    })};
    margin: 0;
`;

export const StyledWrap = styled.div`
    margin-left: 32px;
`;
